import {
  ListOfferRequest,
  ListOfferResponse
} from '@spilca/order_ts/v1/order/model_offer_pb';
import { Sorting } from '@spilca/order_ts/v1/order/common_pb';
import { createPagination, FILTER_PARAMS } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';
import offerFilterConstructor from '../offerFilterConstructor';

const getOfferRequestConstructor = (
  filter: any,
  offerService: any
): Promise<ListOfferResponse.AsObject> => {
  const { queryKey, pageParam, pageSize } = filter;
  const [, params] = queryKey;
  const request = new ListOfferRequest();
  const sort = new Sorting();
  sort.setFieldName('created_at');
  sort.setOrder(1);
  request.setSortingList([sort]);
  const offerFilter = offerFilterConstructor(params);
  const pager = createPagination(
    pageParam || filter[FILTER_PARAMS.page] || 1,
    pageSize
  );
  request.setPagination(pager);
  request.setFilter(offerFilter);
  return getGrpcPromise(offerService)(request);
};

export default getOfferRequestConstructor;
